import React, { useEffect, useState } from "react";

const ReportBug = () => {

  const [publicError, setPublicError] = useState(null);
  const [vendorError, setVendorError] = useState(null);

  async function fetchStatus() {
    const response = await fetch(
      "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/services-status.json", {
      method: "GET",
    });

    const data = await response.json();
    if (data.public.status === "inactive") {
      setPublicError(data.public.message);
    }
    if (data.vendor.status === "inactive") {
      setVendorError(data.vendor.message);
    }
  }
  useEffect(() => {
    fetchStatus();
  }, []);
  return (
    <div>
    {
      publicError && 
        <div style={{backgroundColor: "red", color: "white", padding: "10px", position: "fixed", top: 0, left: 0, right: 0, textAlign: "center",zIndex: 1000}}>
        {publicError}
        </div>
    }
    </div>
  );
};

export default ReportBug;
